/**
 * DG Delivery Timer
 * Countdown vers le prochain cutoff 15h00 Europe/Paris (lun-ven)
 * + date de livraison estimée (expédition + 2 jours ouvrés)
 */
(function () {
  'use strict';

  var DAYS_FR = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
  var MONTHS_FR = [
    'janvier', 'février', 'mars', 'avril', 'mai', 'juin',
    'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'
  ];
  var CUTOFF_HOUR = 15;

  function parisNow() {
    return new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Paris' }));
  }

  function getNextCutoff() {
    var paris = parisNow();
    var day = paris.getDay();
    var hour = paris.getHours();

    var target = new Date(paris);
    target.setHours(CUTOFF_HOUR, 0, 0, 0);

    if (day >= 1 && day <= 5 && hour < CUTOFF_HOUR) {
      // Lun-Ven avant 15h → aujourd'hui
    } else if (day === 5 && hour >= CUTOFF_HOUR) {
      target.setDate(target.getDate() + 3); // → lundi
    } else if (day === 6) {
      target.setDate(target.getDate() + 2); // → lundi
    } else if (day === 0) {
      target.setDate(target.getDate() + 1); // → lundi
    } else {
      // Lun-Jeu après 15h → lendemain
      target.setDate(target.getDate() + 1);
    }

    return target;
  }

  function getShipDate() {
    var paris = parisNow();
    var day = paris.getDay();
    var hour = paris.getHours();
    var ship = new Date(paris);

    if (day >= 1 && day <= 5 && hour < CUTOFF_HOUR) {
      // Expédition aujourd'hui
    } else if (day === 5 && hour >= CUTOFF_HOUR) {
      ship.setDate(ship.getDate() + 3);
    } else if (day === 6) {
      ship.setDate(ship.getDate() + 2);
    } else if (day === 0) {
      ship.setDate(ship.getDate() + 1);
    } else {
      ship.setDate(ship.getDate() + 1);
    }

    return ship;
  }

  function addBusinessDays(startDate, count) {
    var d = new Date(startDate);
    var added = 0;
    while (added < count) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0 && d.getDay() !== 6) added++;
    }
    return d;
  }

  function formatDateFR(date) {
    // Jour de la semaine uniquement (lundi, mardi, …)
    return DAYS_FR[date.getDay()];
  }

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function updateTimer() {
    var countdownEl = document.querySelector('.dg-delivery-countdown');
    var dateEl = document.querySelector('.dg-delivery-date-value');
    if (!countdownEl) return;

    var wrapper = countdownEl.closest('.dg-bb__delivery');
    var maxHours = wrapper ? parseFloat(wrapper.dataset.dgDeliveryMaxHours || '20') : 20;

    var now = parisNow();
    var cutoff = getNextCutoff();
    var diff = cutoff.getTime() - now.getTime();

    if (diff <= 0) {
      // Cutoff dépassé, recalculer
      setTimeout(updateTimer, 1000);
      return;
    }

    var totalSec = Math.floor(diff / 1000);
    var h = Math.floor(totalSec / 3600);
    var m = Math.floor((totalSec % 3600) / 60);
    var s = totalSec % 60;
    var hoursRemaining = diff / 3.6e6;

    // Affichage avec secondes
    countdownEl.textContent = pad(h) + 'h ' + pad(m) + 'm ' + pad(s) + 's';

    // Affiche / masque le bloc entier selon le seuil max (défaut 20h)
    if (wrapper) {
      if (hoursRemaining > maxHours) {
        wrapper.setAttribute('hidden', '');
      } else {
        wrapper.removeAttribute('hidden');
      }
    }

    if (dateEl) {
      var ship = getShipDate();
      var delivery = addBusinessDays(ship, 2);
      dateEl.textContent = formatDateFR(delivery);
    }
  }

  // Démarrer le timer — update toutes les secondes (HHh MMm SSs affichés)
  if (document.querySelector('.dg-delivery-countdown')) {
    updateTimer();
    setInterval(updateTimer, 1000);
  }
})();
